var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectedSymptom_wrap",style:(_vm.defaultHeight !== undefined && {height:_vm.defaultHeight})},[_c('KvTable',{staticClass:"selectedSymptom",attrs:{"items":_vm.selectedSymptom}}),_c('KvTable',{staticClass:"selectedSymptom",attrs:{"items":_vm.selectedSymptomImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }